import {OrganizationBlock} from "./OrganizationBlock";
import {WeatherBlock} from "./WeatherBlock";
import {MicroFactoryBlock} from "./MicroFactoryBlock";

export const FarmHeader = (props) => {

    const {selectedOrganization, setSelectedOrganization, farmVersion, externalSystemCode,
            smartFarmData} = props;

    return(
      <div className="farm__header">
          <OrganizationBlock
              selectedOrganization={selectedOrganization} setSelectedOrganization={setSelectedOrganization}
          />
          <MicroFactoryBlock
              selectedOrganization={selectedOrganization} farmVersion={farmVersion} externalSystemCode={externalSystemCode}
              smartFarmData={smartFarmData}
          />
          <WeatherBlock selectedOrganization={selectedOrganization}/>
      </div>
    );
}
